var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_c('div',{staticClass:"container"},_vm._l((_vm.images),function(group,idx){return _c('kion-animated-column',{key:idx,attrs:{"images":group,"reversed":idx % 2 !== 0,"shift":idx % 2 !== 0 ? 20 : 0}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }